import { EMPTY_OBJECT } from '../constants';

type StorageKey = 'user' | 'settings';

interface StorageValues {
  user: Record<string, unknown>;
  settings: Record<string, unknown>;
}

export const getLocalStorage = <K extends StorageKey>(key: K): StorageValues[K] => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return EMPTY_OBJECT;
    return JSON.parse(item) as StorageValues[K];
  } catch (err) {
    console.error(`Error reading from localStorage[${key}]:`, err);
    return EMPTY_OBJECT;
  }
};

export const setLocalStorage = <K extends StorageKey>(key: K, value: StorageValues[K]): void => {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (err) {
    console.error(`Error writing to localStorage[${key}]:`, err);
  }
};

export const removeLocalStorage = (key: StorageKey): void => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error(`Error removing localStorage[${key}]:`, err);
  }
};

export const clearLocalStorage = (): void => {
  try {
    localStorage.clear();
  } catch (err) {
    console.error('Error clearing localStorage:', err);
  }
};
